import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store";
import AppThemeProvider from "./components/AppThemeProvider";
import DashboardPage from "./pages/Dashboard/Dashboard";
import AuthPage from "./pages/Auth";
import AdminPage from "./pages/Admin";
import SettingsPage from "./pages/Settings";
import MultiRepricerPage from "./pages/MultiRepricer";
import ProtectedRoute from "./components/ProtectedRoute";
import InvoicesPage from "./pages/Invoices";
import InboundPage from "./pages/JtlServices/Index";
import PlentyPage from "./pages/Plenty";
import TicketsPage from "./pages/Tickets";
import PriceAlertsPage from "./pages/PriceAlerts";
import PrepbusinessPage from "./pages/Prepbusiness";
import StatisticsPage from "./pages/Statistics";
import AnalysisPage from "./pages/Analysis";
import ForecastPage from "./pages/Forecast";
import PennerManagementPage from "./pages/PennerManagement";
import WholesalersPage from "./pages/Wholesalers";
import ShopifyExportPage from "./pages/Temp_Pages/shopify";
import AmazonReportsPage from "./pages/Temp_Pages/amazon_reports";
import TempPagesHub from "./pages/Temp_Pages";
import ObservabilityDebugPage from "./pages/Temp_Pages/observability";

const App = () => {
  return (
    <Provider store={store}>
      <AppThemeProvider>
        <Router>
          <Routes>
            <Route path="/" element={<AuthPage />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <SettingsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/statistics"
              element={
                <ProtectedRoute>
                  <StatisticsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/analysis"
              element={
                <ProtectedRoute>
                  <AnalysisPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/forecast"
              element={
                <ProtectedRoute>
                  <ForecastPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/multi-repricer"
              element={
                <ProtectedRoute>
                  <MultiRepricerPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/invoices"
              element={
                <ProtectedRoute>
                  <InvoicesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/inbound-checker"
              element={
                <ProtectedRoute>
                  <InboundPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/plenty"
              element={
                <ProtectedRoute>
                  <PlentyPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/wholesalers"
              element={
                <ProtectedRoute>
                  <WholesalersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/nexalia"
              element={<Navigate to="/price-alerts" replace />}
            />
            <Route
              path="/godel"
              element={<Navigate to="/price-alerts" replace />}
            />
            <Route
              path="/penner-management"
              element={
                <ProtectedRoute>
                  <PennerManagementPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/price-alerts"
              element={
                <ProtectedRoute>
                  <PriceAlertsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rituals"
              element={<Navigate to="/price-alerts" replace />}
            />
            <Route
              path="/prepbusiness"
              element={
                <ProtectedRoute>
                  <PrepbusinessPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/tickets"
              element={
                <ProtectedRoute>
                  <TicketsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/debug/shopify-export"
              element={
                <ProtectedRoute>
                  <ShopifyExportPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/debug"
              element={
                <ProtectedRoute>
                  <TempPagesHub />
                </ProtectedRoute>
              }
            />
            <Route
              path="/debug/observability"
              element={
                <ProtectedRoute>
                  <ObservabilityDebugPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/debug/amazon/reports"
              element={
                <ProtectedRoute>
                  <AmazonReportsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute adminOnly>
                  <AdminPage />
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Router>
      </AppThemeProvider>
    </Provider>
  );
};

export default App;
